module.exports = __webpack_public_path__ + "img/icon_elearning.6a8ff209.png";